document.addEventListener("DOMContentLoaded", function () {
    // Initialize the Owl Carousel after DOM content is loaded
    const instafeed = document.getElementById("instafeed");

    if (instafeed) {
        $("#instafeed").owlCarousel({
            items: 5.5,
            margin: 15,
            nav: true,
            navText: [
                `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#111111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
                `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#111111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`
            ],
            responsive: {
                0: {
                    items: 4.5,
                    margin: 5
                },
                1000: {
                    margin: 16,
                    items: 5.5
                }
            }
        });
    } else {
        console.error("Instafeed element not found.");
    }
});